import { createContext, useContext } from 'react';

export interface ActiveTradesContextType {
  selectedListingIds: string[];
  setSelectedListingIds: (ids: string[]) => void;
  addSelectedListingId: (id: string) => void;
  removeSelectedListingId: (id: string) => void;
  clearSelectedListingIds: () => void;
}

export const ActiveTradesContext = createContext<ActiveTradesContextType | undefined>(undefined);

export const useActiveTradesContext = (): ActiveTradesContextType => {
  const context = useContext(ActiveTradesContext);
  if (!context) {
    throw new Error('useActiveTradesContext must be used within an ActiveTradesProvider');
  }
  return context;
};
